import { render, staticRenderFns } from "./FocReason.vue?vue&type=template&id=53a21405&scoped=true&"
import script from "./FocReason.vue?vue&type=script&lang=js&"
export * from "./FocReason.vue?vue&type=script&lang=js&"
import style0 from "./FocReason.vue?vue&type=style&index=0&id=53a21405&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a21405",
  null
  
)

export default component.exports